import styled from 'styled-components'

export const StyledFinanceSubWrapper = styled.ol`
    padding-left: 17px;  
`
